import { HOST, MOKA_SERVICE_HOST } from '../constants';

export const VERIFY_EMAIL = `${HOST}/verify_email`;
export const VERIFY_EMAIL_V2 = `${MOKA_SERVICE_HOST}/account/v2/registrations/email/verification`;
